import { useState, useEffect } from "react";
import api from "../api";
import { resolveMediaUrl } from "../utils/url";

// Admin-Seite zur Verwaltung der Social-Plattformen
export default function AdminSocialPlatforms() {
  const [platforms, setPlatforms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editIdx, setEditIdx] = useState(null);
  const [form, setForm] = useState({ name: "", urlPattern: "", icon: "", useFavicon: false });
  const [iconFile, setIconFile] = useState(null);
  const [iconList, setIconList] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    api.get("/admin/social-platforms").then(res => {
      setPlatforms(res.data);
    }).catch(err => {
      console.error("/admin/social-platforms failed:", err?.response?.status, err?.response?.data || err.message);
      setError(err?.response?.data?.error || "Fehler beim Laden der Plattformen");
    }).finally(() => setLoading(false));
    api.get("/admin/social-icons").then(res => setIconList(res.data)).catch(err => {
      console.warn("/admin/social-icons failed:", err?.response?.status, err?.response?.data || err.message);
    });
  }, []);

  const handleEdit = idx => {
    setEditIdx(idx);
    setForm({ ...platforms[idx], useFavicon: false });
    setIconFile(null);
    setError("");
    setSuccess("");
  };

  const handleDelete = async idx => {
    if (!window.confirm("Wirklich löschen?")) return;
    try {
      await api.delete(`/admin/social-platforms/${platforms[idx].id}`);
      setPlatforms(p => p.filter((_, i) => i !== idx));
      setEditIdx(null);
      setSuccess("Plattform gelöscht.");
    } catch (e) {
      setError("Fehler beim Löschen.");
    }
  };

  const handleSave = async () => {
    setError("");
    setSuccess("");
    try {
      let iconUrl = form.icon;
      if (iconFile) {
        const fd = new FormData();
        fd.append("icon", iconFile);
        const uploadRes = await api.post("/admin/social-platforms/icon", fd, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        iconUrl = uploadRes.data.iconUrl;
      }
      let res;
      if (editIdx !== null) {
        res = await api.patch(`/admin/social-platforms/${platforms[editIdx].id}`, { ...form, icon: iconUrl });
        setPlatforms(p => p.map((pl, i) => i === editIdx ? res.data : pl));
      } else {
        res = await api.post("/admin/social-platforms", { ...form, icon: iconUrl });
        setPlatforms(p => [...p, res.data]);
      }
      setEditIdx(null);
      setForm({ name: "", urlPattern: "", icon: "" });
      setIconFile(null);
      setSuccess("Gespeichert.");
    } catch (e) {
      setError("Fehler beim Speichern.");
    }
  };

  return (
    <div className="home-page">
      <section style={{width:'100vw',margin:0,padding:0}}></section>
      <section style={{width:'100%',maxWidth:700,margin:'40px auto',padding:32,color:'#fff'}}>
        <h2 style={{textAlign:'center', fontSize:'1.3em', fontWeight:600, marginBottom:18}}>Social-Plattformen verwalten</h2>
        {success && <div style={{color:'green',marginBottom:12, fontWeight:500}}>{success}</div>}
        {error && <div style={{color:'red',marginBottom:12}}>{error}</div>}
        <table style={{width:'100%',marginBottom:24}}>
          <thead>
            <tr style={{background:'rgba(255,255,255,0.05)'}}>
              <th>Name</th>
              <th>URL-Muster</th>
              <th>Icon</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {platforms.map((pl, idx) => (
              <tr key={pl.id || idx}>
                <td>{pl.name}</td>
                <td>{pl.urlPattern}</td>
                <td>{pl.icon ? <img src={pl.icon.startsWith('http') ? pl.icon : resolveMediaUrl(pl.icon)} alt="Icon" style={{width:32,height:32}} /> : "-"}</td>
                <td>
                  <button type="button" onClick={()=>handleEdit(idx)} style={{marginRight:8}}>Bearbeiten</button>
                  <button type="button" onClick={()=>handleDelete(idx)} style={{color:'#c00'}}>Löschen</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{marginBottom:24}}>
          <h3>{editIdx !== null ? "Plattform bearbeiten" : "Neue Plattform hinzufügen"}</h3>
          <input type="text" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Name" style={{width:'30%',marginRight:8}} />
          <input type="text" value={form.urlPattern} onChange={e=>setForm(f=>({...f,urlPattern:e.target.value}))} placeholder="URL-Muster (z.B. instagram.com)" style={{width:'40%',marginRight:8}} />
          <div style={{margin:'8px 0'}}>
            <b>Icon auswählen:</b>
            <div style={{display:'flex',gap:8,flexWrap:'wrap',margin:'8px 0'}}>
              {iconList.map(icon => (
                <img
                  key={icon}
                  src={icon.startsWith('http') ? icon : resolveMediaUrl(icon)}
                  alt="Icon"
                  style={{width:32,height:32,border:form.icon===icon?'2px solid #32CD89':'2px solid transparent',borderRadius:6,cursor:'pointer'}}
                  onClick={()=>setForm(f=>({...f,icon:icon}))}
                  title={icon}
                />
              ))}
            </div>
            <input type="text" value={form.icon} onChange={e=>setForm(f=>({...f,icon:e.target.value}))} placeholder="Icon-URL" style={{width:'20%',marginRight:8}} />
            <input type="file" accept="image/*" onChange={e=>setIconFile(e.target.files[0])} style={{marginRight:8}} />
          </div>
          <button type="button" onClick={handleSave} style={{marginRight:8}}>{editIdx !== null ? "Speichern" : "Hinzufügen"}</button>
          {editIdx !== null && <button type="button" onClick={()=>{setEditIdx(null);setForm({name:"",urlPattern:"",icon:""});setIconFile(null);}}>Abbrechen</button>}
        </div>
      </section>
    </div>
  );
}
